import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import MTRDateTable from "./MTRDateTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { DownloadButtonDate, DownloadExcelButtonDate } from "./DownloadButton";
import { monthlyTradesReportLocation } from "./Locations";
import { RouteComponentProps } from "react-router-dom";
import { useCurrentTradesReportFilter } from "../../../data/reports/monthlyTrade/hooks/useTradesReportFilter";

export interface MTRDatePageInfo {
  year: string;
  month: string;
}

export interface MTRDatePageProps extends RouteComponentProps<MTRDatePageInfo> {
  userAccessRights: AccessRights;
}

const MTRDatePage: React.FunctionComponent<MTRDatePageProps> = (props) => {
  const pageStyles = usePageStyles();

  // ovde su parametri za izvestaj
  // zbog toga stho se uzimaju iz URL-a moraju biti tipa string, ali ih konvertujem u number zbog toga sto to trazi API
  // dalje ih treba proslediti u odgovarajuci hook da bi se sacuvali u filteru u redux store-u
  const yearNumber = Number(props.match.params.year);
  const monthNumber = Number(props.match.params.month);
  console.log("Report params:", yearNumber, monthNumber);

  const [
    filter,
    setReportDate,
    setReportMonth,
    setReporthYear,
  ] = useCurrentTradesReportFilter();

  React.useEffect(() => setReportMonth(monthNumber), [monthNumber]);
  React.useEffect(() => setReporthYear(yearNumber), [yearNumber]);

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={
                <PageTitle
                  title="mTReportDateTitle"
                  backLocation={monthlyTradesReportLocation}
                />
              }
              action={<MonthActions />}
            />
            <Divider />
            <CardContent>
              <MTRDateTable userAccessRights={props.userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const MonthActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadButtonDate />
    </Grid>
    <Grid item>
      <DownloadExcelButtonDate />
    </Grid>
  </Grid>
);

export default MTRDatePage;
